<!-- Affichage des attributs favoris-->
<div class="favorite-container">
    <fa-icon [icon]="starIcon" class="favorite-icon"></fa-icon>

    <div class="attributes-div favorites-div">
        @for (attributeDefinition of favoriteAttributesDefinitions; track attributeDefinition.id) {
            @if (attributeDefinition.propertyCode !== BOX_ID && attributeDefinition.propertyCode !== WORKFLOW_ID) {
                <app-attribute
                    [readonly]="true"
                    class="attributes-value"
                    [attributeDefinition]="attributeDefinition"
                    [value]="folder | avmAttributeFieldPipe: attributeDefinition"></app-attribute>
            }
        }
    </div>

    <button
        mat-mini-fab
        class="accent-button small"
        aria-label="Afficher les fichiers favoris"
        matTooltip="Afficher les fichiers favoris"
        matTooltipPosition="below"
        (click)="onDisplayFavoriteAttachments()">
        <fa-icon [icon]="attachmentIcon"></fa-icon>
    </button>

    <ngx-spinner name="favorite-spinner" [fullScreen]="false" type="timer" size="default"></ngx-spinner>
</div>
